import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FilterModel} from './regisafe-extended-search/filter.model';
import {RegisafeExtendedSearchComponent} from './regisafe-extended-search/regisafe-extended-search.component';
import {RegisafeDatastoresComponent} from './regisafe-datastores/regisafe-datastores.component';
import {RegisafeFilterComponent} from './regisafe-filter/regisafe-filter.component';
import {RegisafeHeaderComponent} from './regisafe-header/regisafe-header.component';
import {RegisafeFooterComponent} from './regisafe-footer/regisafe-footer.component';
import {RegisafeSearchFormsComponent} from './regisafe-search-forms/regisafe-search-forms.component';
import {RegisafeSearchToolbarComponent} from './regisafe-search-toolbar/regisafe-search-toolbar.component';
import {
	RegisafeSuchergebnisseSubsComponent
} from './regisafe-resultlist-substructures/regisafe-suchergebnisse-subs.component';
import {
	RegisafeDetailSubresultlistComponent
} from './regisafe-detail-subresultlist/regisafe-detail-subresultlist.component';
import {RegisafeDetailMetadataComponent} from './regisafe-detail-metadata/regisafe-detail-metadata.component';
import {RegisafeGetfileinfoComponent} from './regisafe-getfileinfo/regisafe-getfileinfo.component';
import {RegisafeBarcodeScannerComponent} from './regisafe-barcode-scanner/regisafe-barcode-scanner.component';
import {ListeArtComponent} from './regisafe-search-forms/liste-art/liste-art.component';
import {ConvertJsonDatePipe, FilterPipe} from '../provider/pipes/filter.pipe';
import {RegisafeRelationsComponent} from './regisafe-relations/regisafe-relations.component';
import {RelationListComponent} from './regisafe-relations/relation-list/relation-list.component';
import {RegisafeResetConfigComponent} from './regisafe-reset-config/regisafe-reset-config.component';
import {ConfigModalComponent} from '../views/anmeldung/config-modal/config-modal.component';
import {RegisafeOfflineLoginComponent} from './regisafe-offline-login/regisafe-offline-login.component';
import {RegisafeMsgViewerComponent} from './regisafe-msg-viewer/regisafe-msg-viewer.component';
import {Nl2brPipe} from '../provider/pipes/nl2br';
import {RegisafeDirectiveModule} from '../directives.module';
@NgModule({
	declarations: [
		RegisafeExtendedSearchComponent,
		RegisafeDatastoresComponent,
		RegisafeFilterComponent,
		RegisafeHeaderComponent,
		RegisafeFooterComponent,
		RegisafeSearchFormsComponent,
		RegisafeSearchToolbarComponent,
		RegisafeSuchergebnisseSubsComponent,
		RegisafeDetailSubresultlistComponent,
		RegisafeDetailMetadataComponent,
		RegisafeGetfileinfoComponent,
		RegisafeBarcodeScannerComponent,
		RegisafeRelationsComponent,
		RegisafeResetConfigComponent,
		RegisafeOfflineLoginComponent,
		RegisafeMsgViewerComponent,
		RelationListComponent,
		ListeArtComponent,
		FilterPipe,
		Nl2brPipe,
		ConvertJsonDatePipe,
		ConfigModalComponent
	],
	imports: [
		IonicModule,
		FontAwesomeModule,
		CommonModule,
		ReactiveFormsModule,
		FormsModule,
		RegisafeDirectiveModule
	],
	exports: [RegisafeExtendedSearchComponent,
		RegisafeDatastoresComponent,
		RegisafeFilterComponent,
		RegisafeHeaderComponent,
		RegisafeFooterComponent,
		RegisafeSearchFormsComponent,
		RegisafeSearchToolbarComponent,
		RegisafeSuchergebnisseSubsComponent,
		RegisafeDetailSubresultlistComponent,
		RegisafeDetailMetadataComponent,
		RegisafeGetfileinfoComponent,
		RegisafeBarcodeScannerComponent,
		RegisafeRelationsComponent,
		RegisafeResetConfigComponent,
		RegisafeOfflineLoginComponent,
		RegisafeMsgViewerComponent,
		RelationListComponent,
		ListeArtComponent,
		ConfigModalComponent],
	providers: [
		FilterModel
	]
})

export class ComponentsModule {
}
